import { useState } from "react";
import { Paper, Stack, Typography, Divider, Tooltip, useTheme, Skeleton, Button, Box } from "@mui/material";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { HugeiconsIcon } from "@hugeicons/react";
import { WhatsappIcon } from "@hugeicons/core-free-icons";
import { formatPhone } from "@/utils/phones";
import AddClientPointsDialog from "./AddClientPointsDialog";
import ClientAvatar from "@/components/ClientAvatar";

interface Props {
    isLoading: boolean;
    isSuccess: boolean;
    client: any;
    loyaltyAccount: any;
}

const DataField = ({ label, value, direction = "row" }: { label: string; value: string, direction?: "row" | "column" }) => {
    return (
        <Stack direction={direction} spacing={direction === 'row' ? 2 : 0.5} alignItems={"center"}>
            <Typography variant="body1" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body2" color="text.primary">
                {value}
            </Typography>
        </Stack>
    );
};

const LoyaltyClientProfile = ({ isLoading, isSuccess, client, loyaltyAccount }: Props) => {
    const { palette } = useTheme();
    const [isAddPointsDialogOpen, setIsAddPointsDialogOpen] = useState(false);

    const contactClient = () => {
        const message = `Hola ${client.name}!`;
        window.open(`https://wa.me/505${client.phone}?text=${message}`);
    };

    if (isLoading) {
        return (
            <Stack spacing={2} >
                <Skeleton variant="rounded" height={300} />
                <Skeleton variant="rounded" height={75} />
            </Stack>
        )
    }

    if (!isSuccess) {
        return null;
    }

    return (
        <Stack spacing={2}>
            <Paper>
                <Box p={3} pt={5}>
                    <ClientAvatar client={client} />
                </Box>
                <Divider />
                {client ? (
                    <Stack spacing={2} p={2}>
                        <DataField direction="column" label="Nombre" value={`${client.name} ${client.lastname || ""}`} />
                        {loyaltyAccount?.joinedAt ? (
                            <DataField direction="column" label="Miembro desde" value={format(Number(loyaltyAccount.joinedAt), "dd 'de' MMMM, yyyy", { locale: es })} />
                        ) : null}
                    </Stack>
                ) : null}
                <Stack p={2}>
                    <Button
                        size="large"
                        color="success"
                        onClick={() => {
                            setIsAddPointsDialogOpen(true);
                        }}
                    >
                        Agregar Puntos
                    </Button>
                </Stack>
            </Paper>

            <Paper sx={{ p: 3 }}>
                <Stack direction={"row"} spacing={2} alignItems={"center"}>
                    <Tooltip title="Enviar mensaje" placement="top" arrow>
                        <HugeiconsIcon icon={WhatsappIcon} color={palette.primary.main} size={22} onClick={contactClient} />
                    </Tooltip>
                    <DataField direction="column" label="Whatsapp" value={formatPhone(client?.phone)} />
                </Stack>
            </Paper>

            <AddClientPointsDialog
                open={isAddPointsDialogOpen}
                client={client}
                onClose={() => setIsAddPointsDialogOpen(false)}
            />
        </Stack>
    );
}

export default LoyaltyClientProfile;